import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { NotyService, PaymentService, ErrorHandlerService, UserService } from '@app/services';

export interface ModalPublicProperties {}

@Component({
  selector: 'app-partners-plan-modal',
  templateUrl: './partners-plan-modal.component.html',
  styleUrls: ['./partners-plan-modal.component.scss', '../configurations-plan.component.scss'],
  standalone: false
})
export class PartnersPlanModalComponent implements OnInit, OnDestroy {
  isLoading = false;
  isActivating = false;
  form: UntypedFormGroup;
  ispOptions: any[] = [];

  constructor(
    public modal: NgbActiveModal,
    public translateService: TranslateService,
    private paymentService: PaymentService,
    private formBuilder: UntypedFormBuilder,
    private notyService: NotyService,
    private errorHandlerService: ErrorHandlerService,
    private userService: UserService
  ) {
    this.form = this.formBuilder.group({
      isp_code: ['', Validators.required],
      login: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.loadISPs();
  }

  ngOnDestroy() {}

  close() {
    this.modal.dismiss();
  }

  confirm() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isActivating = true;
    this.form.disable();
    const { isp_code, login, password } = this.form.getRawValue();

    this.paymentService
      .activateCampsoftPlan({ isp_code: String(isp_code), login, password })
      .pipe(
        finalize(() => {
          this.isActivating = false;
          this.form.enable();
        })
      )
      .subscribe({
        next: result => {
          if (result) {
            this.userService.getCurrentUser({ fetchPolicy: 'network-only' }).subscribe({
              next: () => {
                this.modal.close(true);
                this.notyService.success(this.translateService.instant('success.planActivated'));
              },
              error: () => {
                this.modal.close(true);
              }
            });
          } else {
            this.notyService.error(this.translateService.instant('error.planActivation'));
          }
        },
        error: error => {
          this.errorHandlerService.handle(error);
        }
      });
  }

  private loadISPs() {
    this.isLoading = true;
    this.paymentService
      .listCampsoftISPs()
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: isps => {
          this.ispOptions = (isps || []).map(isp => ({
            key: String(isp.identifier),
            value: isp.name,
            height: 46,
            fontSize: 16,
            disabled: false
          }));
        },
        error: error => {
          this.notyService.error(this.translateService.instant('error.loadingISPs'));
        }
      });
  }
}
